import getAccountSubscriptions from 'js/Services/AccountSubscriptions/DataProviders/getAccountSubscriptions.js';
import getAccountSubscriptionsByPlanHandle from 'js/Services/AccountSubscriptions/DataProviders/getAccountSubscriptionsByPlanHandle.js';

class AccountSubscriptionService {

    constructor(authService) {
        this.authService = authService;
        this.getAccountSubscriptions = this.getAccountSubscriptions.bind(this);
        this.getAccountSubscriptionsByPlanHandle = this.getAccountSubscriptionsByPlanHandle.bind(this);
    }

    async getAccountSubscriptions(accountId, includePlanData = true) {
        try {
            return await getAccountSubscriptions(accountId, includePlanData, this.authService);
        } catch (error) {
            console.error('Error fetching account subscriptions:', error);
            throw error;
        }
    }

    async getAccountSubscriptionsByPlanHandle(accountId, planHandle, includePlanData = true) {
        try {
            return await getAccountSubscriptionsByPlanHandle(accountId, planHandle, includePlanData, this.authService);
        } catch (error) {
            console.error('Error fetching account subscriptions by plan handle:', error);
            throw error;
        }
    }

    async hasAnyAccountSubscription(accountId, planHandles) {
        try {
            const subscriptions = await this.getAccountSubscriptions(accountId, true);

            if (!subscriptions.data || !Array.isArray(subscriptions.data)) {
                return false;
            }

            return subscriptions.data.some(subscription =>
                subscription.subscriptionPlan &&
                planHandles.includes(subscription.subscriptionPlan.handle)
            );

        } catch (error) {
            console.error('Error checking account subscription:', error);
            return false;
        }
    }

     async hasAccountSubscription(accountId, planHandle) {
        try {
            const subscriptions = await this.getAccountSubscriptionsByPlanHandle(accountId, planHandle, true);

            if (!subscriptions.data || !Array.isArray(subscriptions.data)) {
                return false;
            }

            return subscriptions.data.length > 0;

        } catch (error) {
            console.error('Error checking account subscription by plan handle:', error);
            return false;
        }
    }

}

export default AccountSubscriptionService;